export const TIMEOUT_CANCELLATION = 'ECONNABORTED';
export const AXIOS_TIMEOUT_ERROR_MESSAGE =
  'Not able to verify due to a network issue. Please refresh or try again later.';
